<template>
  <el-form-item
    :class="{ desktop: isDesktop }"
    label-width="150px"
    label="Connection Type"
  >
    <el-select
      v-model="value"
      multiple
      placeholder="All"
      @update:modelValue="updated"
    >
      <el-option
        v-for="item in options"
        :key="item.key"
        :label="item.label"
        :value="item.key"
      />
    </el-select>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import {
  ConnectionType,
  ConnectionTypeLabel,
  ConnectionTypeLabels
} from '@/api/types'
import useResize from '@/hooks/useResize'

type ConnectionEntry = {
  key: ConnectionType
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'ConnectionTypeSelector',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)

    const options = ConnectionTypeLabels.map<ConnectionEntry>(
      (connectionLabel: ConnectionTypeLabel) => {
        return {
          key: connectionLabel.type_id,
          label: connectionLabel.label,
          disabled: false
        }
      }
    )

    const { isDesktop } = useResize()

    const updated = (newValue: Array<ConnectionType>) => {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { options, updated, isDesktop, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}

.desktop .el-select {
  width: 400px;
}

.el-form-item {
  margin-top: 1em;
}
</style>
